<template>
    <div class="survey_wrap">
        <div class="survey_content">
            <div class="survey_head">
                <img src="../../assets/img/survey_logo.png">
            </div>

            <div style="margin-top: 15px">

            </div>

            <div class="title">
                <span>{{ title1 }}</span>
            </div>

            <div class="title">
                <span>{{ title2 }}</span>
            </div>

            <div class="paragraph">
                <span>基本信息</span>
            </div>

            <div class="base_wrap">

<!--                <div class="base_item">-->
<!--                    <span class="star">*</span>-->
<!--                    <div class="base_item_input">-->
<!--                        <span>姓名</span>-->
<!--                        <input type="text" v-model="data.name">-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="base_item">-->
<!--                    <span class="star">*</span>-->
<!--                    <div class="base_item_input">-->
<!--                        <span>联系电话</span>-->
<!--                        <input type="tel" v-model="data.phone">-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="base_item">-->
<!--                    <span class="star">*</span>-->
<!--                    <div class="base_item_input">-->
<!--                        <span>医生职业证书编号</span>-->
<!--                        <input type="text" v-model="data.certificate">-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="base_item">-->
<!--                    <span class="star" style="opacity: 0">*</span>-->
<!--                    <div class="base_item_input">-->
<!--                        <span>请上传证书照片</span>-->
<!--                        <input type="text" placeholder="点击上传" v-model="data.licence" readonly/>-->
<!--                        <input style="width: 100%" class="licence_img" type="file" accept="image/*"-->
<!--                               @change="licenceUpload"/>-->
<!--                    </div>-->
<!--                    <div class="licence_img_show" v-if="licence != ''">-->
<!--                        <img id="licence" alt="营业执照"/>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="base_item">
                    <span class="star">*</span>
                    <div class="base_item_input">
                        <span>职业范围</span>
                        <input type="text" v-model="data.career">
                    </div>
                </div>

                <div class="base_item" @click="showPopup(1)">
                    <span class="star">*</span>
                    <div class="base_item_input">
                        <span>目前职称</span>
                        <input type="text" v-model="data.title" readonly>
                        <div class="arrow"></div>
                    </div>
                </div>

                <div class="base_item" @click="showPopup(2)">
                    <span class="star">*</span>
                    <div class="base_item_input">
                        <span>所属科室</span>
                        <input type="text" v-model="data.dept" readonly>
                        <div class="arrow"></div>
                    </div>
                </div>
            </div>

            <div class="paragraph">
                <span>问卷调查</span>
            </div>

            <div class="survey-wrap">
                <div class="pdf">
                    <span>中国心血管病一级预防指南（下载）</span>
                    <img src="../../assets/img/pdf.png">
                    <!--           https://ymd-lcc.oss-cn-beijing.aliyuncs.com/aslk/survey.pdf-->
                    <a href="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/aslk/survey.pdf" download="模板.pdf">模板下载</a>
                </div>

                <div class="survey_item">
                    <span> 1. 您每周就诊的患者中血脂异常患者约</span>
                    <input type="number" v-model="data.title_1_1" pattern="[0-9]*"/>
                    <span> 人次<br>约占</span>
                    <input type="number" v-model="data.title_1_2"/>
                    <span> %<br>其中血脂异常患者中伴有高血压的患者占 </span>
                    <input type="number" v-model="data.title_1_3"/>
                    <span> % <br>其中血脂异常患者中伴有糖尿病的患者占 </span>
                    <input type="number" v-model="data.title_1_4"/>
                    <span> % </span>
                </div>

                <div class="survey_item">
                    <span> 2. 您估计您所管理的患者中LDL-C控制达标率大约 </span>
                    <input type="number" v-model="data.title_2"/>
                    <span>%</span>
                </div>

                <div class="survey_item">
                    <span>3. 对于血脂异常患者，您会根据ASCVD危险分层结果决定血脂控制目标吗？</span>
                </div>

                <div class="radio">
                    <div class="radio-item">
                        <input name="sex" type="radio" checked="checked" id="3_1" v-model="data.title_3" value="会"/>
                        <label for="3_1">会</label>
                    </div>
                    <div class="radio-item">
                        <input name="sex" type="radio" id="3_2" v-model="data.title_3" value="不会"/>
                        <label for="3_2">不会</label>
                    </div>
                </div>

                <div class="survey_item">
                    <span>4. 对于血脂异常患者，您认为以下哪些应作为评估ASCVD风险的指标?</span>
                </div>
                <div class="radio">
                    <div class="radio-item-1">
                        <input type="checkbox" name="4_1" id="4_1" v-model="data.title_4" :value="options4[0].value">
                        <label for="4_1">{{options4[0].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input type="checkbox" name="4_2" id="4_2" v-model="data.title_4" :value="options4[1].value"/>
                        <label for="4_2">{{options4[1].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input type="checkbox" name="4_3" id="4_3" v-model="data.title_4" :value="options4[2].value"/>
                        <label for="4_3">{{options4[2].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input name="4_4" id="4_4" type="checkbox" v-model="data.title_4" :value="options4[3].value"/>
                        <label for="4_4">{{options4[3].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input type="checkbox" name="4_5" id="4_5" v-model="data.title_4" :value="options4[4].value"/>
                        <label for="4_5">{{options4[4].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input name="4_6" id="4_6" type="checkbox" v-model="data.title_4" :value="options4[5].value"/>
                        <label for="4_6">{{options4[5].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input name="4_7" id="4_7" type="checkbox" v-model="data.title_4" :value="options4[6].value"/>
                        <label for="4_7">{{options4[6].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input name="4_8" id="4_8" type="checkbox" v-model="data.title_4" :value="options4[7].value"/>
                        <label for="4_8">{{options4[7].label}}</label>
                    </div>
                </div>

                <div class="survey_item">
                    <span> 5. 对于血脂异常患者，您认为以下哪些应作为评估降脂治疗的靶点？</span>
                </div>
                <div class="radio">
                    <div class="radio-item-1">
                        <input name="5_1" type="checkbox" id="5_1" :value="options5[0].value" v-model="data.title_5"/>
                        <label for="5_1">{{options5[0].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input name="5_2" type="checkbox" id="5_2" :value="options5[1].value" v-model="data.title_5"/>
                        <label for="5_2">{{options5[1].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input name="5_3" type="checkbox" id="5_3" :value="options5[2].value" v-model="data.title_5"/>
                        <label for="5_3">{{options5[2].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input name="5_4" type="checkbox" id="5_4" :value="options5[3].value" v-model="data.title_5"/>
                        <label for="5_4">{{options5[3].label}}</label>
                    </div>
                    <div class="radio-item-1">
                        <input name="5_5" type="checkbox" id="5_5" :value="options5[4].value" v-model="data.title_5"/>
                        <label for="5_5">{{options5[4].label}}</label>

                    </div>
                </div>

                <div class="survey_item">
                    <span> 6. ASCVD风险不同患者的血脂控制的目标为: </span>
                </div>
                <div class="input_item">
                    <label>6.1、糖尿病合并ASCVD高危患者<br>LDL-C目标为&lt;</label>
                    <input type="number" v-model="data.title_6_1_1"/>
                    <label>mmol/L， 非HDL-C目标为&lt;</label>
                    <input type="number" v-model="data.title_6_1_2"/>
                    <label>mmol/L</label>
                </div>
                <div class="input_item">
                    <label>6.2、非糖尿病的ASCVD高危患者<br>LDL-C目标为&lt;</label>
                    <input type="number" v-model="data.title_6_2_1"/>
                    <label>mmol/L， 非HDL-C目标为&lt;</label>
                    <input type="number" v-model="data.title_6_2_2"/>
                    <label>mmol/L</label>
                </div>
                <div class="input_item">
                    <label>6.3、ASCVD中危患者<br>LDL-C目标为&lt;</label>
                    <input type="number" v-model="data.title_6_3_1"/>
                    <label>mmol/L， 非HDL-C目标为&lt;</label>
                    <input type="number" v-model="data.title_6_3_2"/>
                    <label>mmol/L</label>
                </div>
                <div class="input_item">
                    <label>6.4、ASCVD低危患者<br>LDL-C目标为&lt;</label>
                    <input type="number" v-model="data.title_6_4_1"/>
                    <label>mmol/L， 非HDL-C目标为&lt;</label>
                    <input type="number" v-model="data.title_6_4_2"/>
                    <label>mmol/L</label>
                </div>

                <div class="survey_item">
                    <span> 7. 高血压患者 ，LDL 目标至少应&lt; </span>
                    <input type="number" v-model="data.title_7"/>
                    <span> mmol/L </span>
                </div>

                <div class="survey_item">
                    <span> 8. 年龄≥40 岁的糖尿病患者， LDL 目标应&lt; </span>
                    <input type="number" v-model="data.title_8"/>
                    <span> mmol/L </span>
                </div>

                <div class="survey_item">
                    <span>9. 年龄20~39岁的糖尿病患者，且ASCVD总体风险为高危者，LDL 目标应 &lt;</span>
                    <input type="number" v-model="data.title_9"/>
                    <span> mmol/L </span>
                </div>

                <div class="survey_item">
                    <span>10. 相对于西方人群，亚洲/中国血脂异常人群具有什么特点？</span>
                </div>

                <div class="radio">
                    <div class="radio-item-2">
                        <input type="checkbox" id="10_1" :value="options10[0].value" v-model="data.title_10"/>
                        <label for="10_1">{{options10[0].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input name="sex" type="checkbox" id="10_2" :value="options10[1].value"
                               v-model="data.title_10"/>
                        <label for="10_2">{{options10[1].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input name="sex" type="checkbox" id="10_3" :value="options10[2].value"
                               v-model="data.title_10"/>
                        <label for="10_3">{{options10[2].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input name="sex" type="checkbox" id="10_4" :value="options10[3].value"
                               v-model="data.title_10"/>
                        <label for="10_4">{{options10[3].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input name="sex" type="checkbox" id="10_5" :value="options10[4].value"
                               v-model="data.title_10"/>
                        <label for="10_5">{{options10[4].label}}</label>
                    </div>
                </div>

                <div class="survey_item">
                    <span>11. 基于中国国情，您认为哪些是适合中国患者的调脂治疗策略？</span>
                </div>
                <div class="radio">
                    <div class="radio-item-2">
                        <input name="sex" type="checkbox" id="11_1" :value="options11[0].value"
                               v-model="data.title_11"/>
                        <label for="11_1">{{options11[0].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input name="sex" type="checkbox" id="11_2" :value="options11[1].value"
                               v-model="data.title_11"/>
                        <label for="11_2">{{options11[1].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input name="sex" type="checkbox" id="11_3" :value="options11[2].value"
                               v-model="data.title_11"/>
                        <label for="11_3">{{options11[2].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input name="sex" type="checkbox" id="11_4" :value="options11[3].value"
                               v-model="data.title_11"/>
                        <label for="11_4">{{options11[3].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input name="sex" type="checkbox" id="11_5" :value="options11[4].value"
                               v-model="data.title_11"/>
                        <label for="11_5">{{options11[4].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input name="sex" type="checkbox" id="11_6" :value="options11[5].value"
                               v-model="data.title_11"/>
                        <label for="11_6">{{options11[5 ].label}}</label>
                    </div>
                </div>

                <div class="survey_item">
                    <span> 12. 以下哪些属于中等强度他汀？ </span>
                </div>
                <div class="radio">
                    <div class="radio-item-2">
                        <input type="checkbox" id="12_1" :value="options12[0].value" v-model="data.title_12"/>
                        <label for="12_1">{{options12[0].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input type="checkbox" id="12_2" :value="options12[1].value" v-model="data.title_12"/>
                        <label for="12_2">{{options12[1].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input type="checkbox" id="12_3" :value="options12[2].value" v-model="data.title_12"/>
                        <label for="12_3">{{options12[2].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input type="checkbox" id="12_4" :value="options12[3].value" v-model="data.title_12"/>
                        <label for="12_4">{{options12[3].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input type="checkbox" id="12_5" :value="options12[4].value" v-model="data.title_12"/>
                        <label for="12_5">{{options12[4].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input type="checkbox" id="12_6" :value="options12[5].value" v-model="data.title_12"/>
                        <label for="12_6">{{options12[5].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input type="checkbox" id="12_7" :value="options12[6].value" v-model="data.title_12"/>
                        <label for="12_7">{{options12[6].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input type="checkbox" id="12_8" :value="options12[7].value" v-model="data.title_12"/>
                        <label for="12_8">{{options12[7].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input type="checkbox" id="12_9" :value="options12[8].value" v-model="data.title_12"/>
                        <label for="12_9">{{options12[8].label}}</label>
                    </div>
                    <div class="radio-item-2">
                        <input type="checkbox" id="12_10" :value="options12[9].value" v-model="data.title_12"/>
                        <label for="12_10">{{options12[9].label}}</label>
                    </div>
                </div>
            </div>

            <div class="submit" @click="surveySubmit">
                <span>提交</span>
            </div>
            <div class="survey_bottom"></div>
        </div>

        <mt-popup
                class="popup"
                v-model="popupShow"
                popup-transition="popup-fade"
                closeOnClickModal="true"
                position="bottom"
        >
            <mt-picker :slots="slots" @change="popupValuesChange" showToolbar>
                <div class="picker-toolbar-title">
                    <div class="usi-btn-cancel" @click="popupShow = !popupShow">取消</div>
                    <div class="">请选择</div>
                    <div class="usi-btn-sure" @click="popupalueAdd">确定</div>
                </div>
            </mt-picker>
        </mt-popup
        >
    </div>
</template>

<script>
    import {aslkDoSurvey} from "@/assets/js/api";
    import {getOssSecret} from "@/assets/js/api";
    import {getUuid} from "@/assets/util/util";
    import OSS from 'ali-oss';
    import {Indicator} from 'mint-ui';
    import {MessageBox} from 'mint-ui'

    export default {
        name: "",
        data() {
            return {
                title1: "北京健康促进会",
                title2: "血脂代谢异常认知现状调查",
                introduce:"为提高基层医疗血脂代谢异常的管理水平，降低心血管事件的发生发展，推动健康2030目标早日实现，本项目将面向基层医生开展血脂代谢异常认识现状调查，并通过调查分析，摸索总结教育模式，全面推进三高共管的管理水平。再次感谢您的参与!",
                options3: [
                    {
                        label: "不会",
                        value: "不会",
                    },
                    {
                        label: "会",
                        value: "会",
                    },
                ],
                options4: [
                    {
                        label: "TC",
                        value: "A",
                    },
                    {
                        label: "HDL-C",
                        value: "B",
                    },
                    {
                        label: "LDL-C",
                        value: "C",
                    },
                    {
                        label: "TG",
                        value: "D",
                    },
                    {
                        label: "非HDL-C",
                        value: "E",
                    },
                    {
                        label: "高血压",
                        value: "F",
                    },
                    {
                        label: "糖尿病",
                        value: "G",
                    },
                    {
                        label: "吸烟",
                        value: "H",
                    },
                    {
                        label: "年龄",
                        value: "I",
                    },
                ],
                options5: [
                    {
                        label: "TC",
                        value: "A",
                    },
                    {
                        label: "HDL-C",
                        value: "B",
                    },
                    {
                        label: "LDL-C",
                        value: "C",
                    },
                    {
                        label: "TG",
                        value: "D",
                    },
                    {
                        label: "非HDL-C",
                        value: "E",
                    },
                ],
                options10: [
                    {
                        label:
                            "中国人群TC整体水平低于于西方高收入国家，因此调脂强度应有所区别",
                        value: "A",
                    },
                    {
                        label:
                            "中国人群的血脂水平以边缘性升高为主(TC：5.2-6.2mmol/L，LDL-C：3.4-4.1mmol/L)",
                        value: "B",
                    },
                    {
                        label: "对比西方人群，东亚人群对他汀的药物敏感性更高，反应更强",
                        value: "C",
                    },
                    {
                        label:
                            "对比西方人群，安全性是中国人群使用高强度他汀需要重点关注的问题",
                        value: "D",
                    },
                    {
                        label: "对于特定的他汀药物，东亚人群应用相对低剂量的他汀方案",
                        value: "E",
                    },
                ],
                options11: [
                    {
                        label: "起始使用高强度他汀",
                        value: "A",
                    },
                    {
                        label: "起始使用中等强度他汀",
                        value: "B",
                    },
                    {
                        label: "起始使用他汀+其它药物联合治疗",
                        value: "C",
                    },
                    {
                        label: "选择在中国人群中大型RCT研究循证证据的药物",
                        value: "D",
                    },
                    {
                        label: "选择天然多效调脂成分的药物",
                        value: "E",
                    },
                    {
                        label: "选择进入国家医保、低价药及基药目录的药物",
                        value: "F",
                    },
                ],
                options12: [
                    {
                        label: "血脂康 1.2g ",
                        value: "A",
                    },
                    {
                        label: "瑞舒伐他汀 5-10mg",
                        value: "B",
                    },
                    {
                        label: "瑞舒伐他汀 20mg",
                        value: "C",
                    },
                    {
                        label: "辛伐他汀 20–40 mg",
                        value: "D",
                    },
                    {
                        label: "普伐他汀 40  mg",
                        value: "E",
                    },
                    {
                        label: "洛伐他汀 40 mg",
                        value: "F",
                    },
                    {
                        label: "氟伐他汀  80 mg",
                        value: "G",
                    },
                    {
                        label: "匹伐他汀 2–4 mg",
                        value: "H",
                    },
                    {
                        label: "阿托伐他汀 10 -20mg",
                        value: "I",
                    },
                    {
                        label: "阿托伐他汀 40 -80mg",
                        value: "J",
                    },
                ],
                licence: "",
                licenceName: "",
                data: {
                    name: "", //姓名
                    phone: "", //手机号
                    certificate: "", //证书
                    career: "", //职业
                    title: "", //职称
                    dept: "", //科室
                    title_1_1: "",
                    title_1_2: "",
                    title_1_3: "",
                    title_1_4: "",
                    title_2: "",
                    title_3: "",
                    title_4: [],
                    title_5: [],
                    title_6_1_1: "",
                    title_6_1_2: "",
                    title_6_2_1: "",
                    title_6_2_2: "",
                    title_6_3_1: "",
                    title_6_3_2: "",
                    title_6_4_1: "",
                    title_6_4_2: "",
                    title_7: "",
                    title_8: "",
                    title_9: "",
                    title_10: [],
                    title_11: [],
                    title_12: [],
                    licence: "",
                },
                popupShow: false,
                // popupVisible: false,
                // popupType:0,
                // popupSure:"",
                slots: [
                    {
                        values: [1, 2, 3, 45],
                    },
                ],
                ossKeySecret: "",
                ossPrefix: "talk/survey/",
            };
        },
        methods: {
            pdfLoad() {

                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = "https://ymd-lcc.oss-cn-beijing.aliyuncs.com/aslk/survey.pdf";
                link.setAttribute('download', `调查.pdf`)
                document.body.appendChild(link)
                link.click()

                // localStorage.setItem("redirect","1")
                // localStorage.setItem("data",this.data)

            },
            async getSecret() {
                const res = await getOssSecret();
                console.log(res, "secret res");
                if (res.data.success == true) {
                    this.ossKeySecret = res.data.data.accessKeySecret;
                }
            },
            licenceUpload(event) {
                console.log(event)
                this.licence = event.target.files[0];
                this.licenceName = event.target.files[0].name;

                var fr = new FileReader();
                fr.readAsDataURL(this.licence);
                fr.onload = function (e) {
                    let image = new Image();
                    image.src = e.target.result;
                    document.getElementById("licence").src = image.src;
                };
            },
            surveySubmit() {

                if (this.data.career == "" || this.data.title == "" || this.data.dept == "") {
                    this.$toast("请填写基本信息");
                    return;
                }

                if (this.data.title_1_1 == "" || this.data.title_1_2 == "" || this.data.title_1_3 == "" || this.data.title_1_4 == "") {
                    this.$toast("请填写第1题");
                    return;
                }

                if (this.data.title_2 == "") {
                    this.$toast("请填写第2题");
                    return;
                }

                if (this.data.title_3 == "") {
                    this.$toast("请填写第3题");
                    return;
                }

                if (this.data.title_4 == "") {
                    this.$toast("请填写第4题");
                    return;
                }
                if (this.data.title_5 == "") {
                    this.$toast("请填写第5题");
                    return;
                }

                if (
                    this.data.title_6_1_1 == "" ||
                    this.data.title_6_1_2 == "" ||
                    this.data.title_6_2_1 == "" ||
                    this.data.title_6_2_2 == "" ||
                    this.data.title_6_3_1 == "" ||
                    this.data.title_6_3_2 == "" ||
                    this.data.title_6_4_1 == "" ||
                    this.data.title_6_4_2 == ""
                ) {
                    this.$toast("请填写第6题");
                    return;
                }

                if (this.data.title_7 == "") {
                    this.$toast("请填写第7题");
                    return;
                }

                if (this.data.title_8 == "") {
                    this.$toast("请填写第8题");
                    return;
                }

                if (this.data.title_9 == "") {
                    this.$toast("请填写第9题");
                    return;
                }

                if (this.data.title_10 == "") {
                    this.$toast("请填写第10题");
                    return;
                }

                if (this.data.title_11 == "") {
                    this.$toast("请填写第11题");
                    return;
                }

                if (this.data.title_12 == "") {
                    this.$toast("请填写第12题");
                    return;
                }

                console.log(this.data.title_12.join(), "title_12")

                console.log(this.data.licence, "licence==");
                let _this = this
                if (this.licence != '') {
                    Indicator.open({
                        text: '上传中',
                        spinnerType: 'fading-circle'
                    });
                    this.ossUpload(this.licence, _this.licenceName).then(function (res) {
                        // console.log(res)
                        Indicator.close()
                        _this.data.licence = res
                        _this.doSurvey(_this.data)
                    })
                } else {
                    this.doSurvey(_this.data);
                }

            },
            async doSurvey(data) {
                let res = await aslkDoSurvey({data});
                console.log(res);

                MessageBox({
                    title: '',
                    message: "恭喜您，提交成功",
                    showCancelButton: false
                }).then(() => {
                    location.reload()
                });

                // MessageBox.confirm("恭喜提交成功", "").then(() => {
                //     location.reload()
                // });

                // this.$toast("提交成功");
                // setTimeout(function () {
                //     location.reload(); //休眠一秒后刷新
                // }, 1000);

            },

            async ossUpload(file, name) {

                let client = new OSS({
                    region: 'oss-cn-beijing',
                    accessKeyId: 'LTAINtmi5XZ7NaV5',
                    accessKeySecret: this.ossKeySecret,
                    bucket: 'ymd-lcc'
                })

                let uuid = getUuid()
                uuid += ("." + name.split(".")[1])
                let key = this.ossPrefix + uuid

                let link = ""

                await client.put(key, file).then(function (res) {

                    let str = res.res.requestUrls[0]
                    let status = res.res.status
                    if (status == 200) {
                        const workLink = str.split("?")[0];
                        link = workLink
                        console.log("上传成功")
                    } else {
                        this.$toast("上传失败")
                    }
                }).catch((err) => {
                    // Indicator.close();
                    console.log(err, "异常啦")
                    this.$toast("无法获取视频，请更换手机重试")
                })

                return link
            },

            popupValuesChange(picker, values) {
                this.popupSure = values[0];
            },
            popupalueAdd() {
                console.log(this.popupType, "type===");
                if (this.popupType == 1) {
                    this.data.title = this.popupSure;
                } else {
                    this.data.dept = this.popupSure;
                }
                this.popupShow = false;
            },
            showPopup(type) {
                console.log(type, "type==");
                if (type == 1) {
                    this.slots[0].values = [
                        "主任医师",
                        "副主任医师",
                        "主治医师",
                        "住院医师",
                        "其他",
                    ];
                } else {
                    this.slots[0].values = [
                        "全科",
                        "中医科",
                        "心内科",
                        "内分泌科",
                        "肾内科",
                        "老年科",
                        "其他",
                    ];
                }
                this.popupShow = true;
                this.popupType = type;
            },
            showAgreement(){

                let message = "<div class='agreement-wrap' style='height: 500px;overflow: scroll'><div style='font-weight: bold;color: #000;font-size: 15px'>知情同意</div>"+
                    "<div style='text-indent: 25px;text-align: left;font-size: 13px;line-height: 25px'>为提高基层医疗血脂代谢异常的管理水平，降低心血管事件的发生发展，推动健康2030目标早日实现，本项目将面向基层医生开展血脂代谢异常认识现状调查，并通过调查分析，摸索总结教育模式，全面推进三高共管的管理水平。以下声明请您仔细阅读，感谢您的支持！</div>"+
                    "<div style='text-align: left;color: #000;font-size: 13px' >声明：</div>"+
                    "<div style='text-indent: 15px;font-size: 13px;text-align: left;line-height: 22px'>1、您所提供的个人信息，包括您的姓名、电话、科室、职称、职业证书编号等信息仅用于验证您的真实身份使用；</div>"+
                    "<div style='text-indent: 15px;font-size: 13px;text-align: left;line-height: 22px'>2、本项目主办方及支持方对您的个人信息享有知情权并承担保密的义务；</div>"+
                    "<div style='text-indent: 15px;font-size: 13px;text-align: left;line-height: 22px'>3、本次调研的数据，仅用于项目调研分析参考使用，其调研的原始数据归主办方统一管理；</div>"+
                    "<div style='text-indent: 15px;font-size: 13px;text-align: left;line-height: 22px'>4、本项目将对您所提供的个人信息及调研数据进行脱敏处理，并有义务对其进行保存备份，保存及备份时间自您提交信息之日起至2022年12月30日，届时平台将予以删除；</div>"+
                    "<div style='text-indent: 15px;font-size: 13px;text-align: left;line-height: 22px'>5、本项目所有方不参与任何医疗诊治，亦不承担任何与医疗诊治相关的责任；</div>"+
                    "<div style='text-indent: 15px;font-size: 13px;text-align: left;line-height: 22px'>6、您自愿参与本次项目，且已经得到您所在医院方的同意；</div>"+
                    "<div style='text-indent: 15px;font-size: 13px;text-align: left;line-height: 22px'>7、您参与本次项目，需确保所提供信息的真实性和准确性。</div></div>";
                MessageBox({
                    title: '',
                    confirmButtonText:"已阅读并同意",
                    message: message,
                    showCancelButton: false
                }).then(() => {
                    // location.reload()
                });
            }
        },
        mounted() {
            // console.log("2")
            this.getSecret();
                this.showAgreement()
                this.agreementShow= false
        },
        created() {
            // console.log("1")
            let redirect = localStorage.getItem("redirect")
            // console.log(redirect,"redirect==")
            if (redirect == "1") {
                console.log("数据处理")
                this.data = localStorage.getItem("data")
            }
            localStorage.setItem("redirect", "0")

        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .survey_wrap {
        width: 100%;
        max-width: 400px;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background: #dedede url("../../assets/img/survey.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        font-size: 12px;
    }

    .survey_content {
        position: absolute;
        max-width: 400px;
        top: 0;
        bottom: 0;
        /*background: #dedede;*/
        overflow: scroll;

        .title {
            width: 100%;
            margin: 0 auto;
            font-weight: bold;
            color: #565656;
            font-size: 16px;
            color: #468E4D;
        }
    }

    .paragraph {
        margin-top: 15px;
        background: #468E4D;
        width: 93px;
        color: #fefefe;
        font-weight: bold;
        border-radius: 0 5px 5px 0;
        padding: 2px 0;
        font-size: 15px;
    }


    .base_wrap {
        margin-top: 15px;
    }

    .base_item {
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 25.5px;
        margin-right: 40.5px;
        margin-top: 12px;
        height: 20px;
        position: relative;

        .star {
            color: #DF0808;
            height: 20px;
            line-height: 20px;
            padding-top: 5px;
            font-weight: bold;
        }

        input {
            text-indent: 10px;
            background: transparent;
            border: none;
            outline: none;
            width: 180px;
            color: #10a19a;
            border-radius: 0px;
        }

        .base_item_input {
            height: 25px;
            width: 100%;
            background: #e9f2ea;
            border: 0;
            outline: none;
            text-align: left;
            margin-left: 10px;
            font-weight: bold;
            color: #000;
            position: relative;
            border-radius: 5px;
            display: flex;
            align-items: center;
            text-indent: 5px;

            span {
                /*flex: 1;*/
                /*color: red;*/
                /*display: inline;*/
            }

            input {
                flex: 1;
                /*width: 60%;*/
            }
        }
    }


    .pdf {
        text-align: right;
        font-weight: bold;
        font-size: 14px;
        margin-right: 23.5px;
        padding-top: 2px;
        position: relative;

        img {
            width: 22px;
            height: 22px;
            text-align: center;
        }

        a {
            width: 20px;
            height: 20px;
            position: absolute;
            right: 0;
            opacity: 0;
        }
    }


    .survey-wrap {
        width: 100%;
    }


    .input_item {
        text-align: left;
        margin: 0 10px;
        padding: 10px 0 10px 15px;
        border-bottom: dashed 1px #999;

        input {
            text-indent: 2px;
            background: transparent;
            border-left: 0px;
            border-right: 0px;
            border-top: 0px;
            border-radius: 0px;
            outline: none;
            border-bottom:   #999 solid 1px;

            width: 30px;
            height: 15px;
            color: #10a19a;
        }
    }

    .survey_item {
        background: #d7e4db;
        margin-left: 10px;
        margin-right: 15px;
        margin-top: 10px;

        border-radius: 10px;
        font-weight: bold;
        text-align: left;
        color: #468E4D;

        padding: 10px 0 10px 20px;
        text-indent: -10px;

        > span {
            font-weight: bold;
            text-align: left;
        }

        input {
            text-indent: 5px;
            background: transparent;
            border-left: 0px;
            border-right: 0px;
            border-top: 0px;
            border-radius: 0px;
            outline: none;
            border-bottom: #aed1ca solid 1px;

            width: 40px;
            height: 15px;
            color: #10a19a;
        }
    }

    .line {
        display: inline;
    }


    .radio {
        display: flex;
        flex-flow: row wrap;
        margin-left: 16px;
        margin-top: 10px;
        text-align: center;
        padding-right: 20px;
        padding-left: 10px;

        input {
            width: 20px;
        }

        display: flex;

        .radio-item {
            width: 20%;
            text-align: left;
            height: 25px;
            margin: 2px 0;
            display: flex;
            align-items: center;
        }

        .radio-item-1 {
            width: 33%;
            text-align: left;
            height: 25px;
            margin: 2px 0;
            display: flex;
            align-items: center;
        }

        .radio-item-2 {
            flex-direction: row;
            width: 100%;
            text-align: left;
            height: 40px;
            margin: 2px 0;
            display: flex;
            /*align-items: center;*/

            /*height: 40px;*/
            input {
                /*width: 120px;*/
                /*height: 120px;*/
            }

            label {
                flex-grow: 1;
                /*color: red;*/
            }
        }
    }

    .subtitle {
        text-align: left;
        font-weight: bold;
    }

    .survey-item {
        margin: 20px 10px;
        text-align: left;

        > span {
            font-weight: bold;
            text-align: left;
        }

        input {
            text-indent: 10px;
            background: transparent;
            border-left: 0px;
            border-right: 0px;
            border-top: 0px;
            border-radius: 0px;
            outline: none;
            border-bottom: #aed1ca solid 1px;

            width: 50px;
            color: #10a19a;
        }

        /*color: #2c3e50;*/
    }

    .mint-radiolist-title {
        background: #0082c5;
    }

    .mint-cell {
        background: transparent;
        margin: 0 10px;
    }

    .mint-cell-wrapper {
    }

    .mint-checkbox-label {
        line-height: 35px;
    }

    .indent {
        margin: 10px 10px;
    }

    .sub-indent {
        text-indent: 20px;
    }

    .submit {
        width: 90%;
        background: #468E4D;
        color: #fff;
        margin: 20px auto 0px auto;
        border-radius: 2px;
        padding: 5px 0;
        font-size: 14px;
    }

    .survey_head {
        /*width: 50px;*/
        /*height: 50px;*/
        /*background: transparent url("../../assets/img/survey_logo.png") ;*/
        /*background-size: contain;*/
        /*display: flex;*/
        /*align-items: flex-end;*/
        /*display: flex;*/
        /*justify-content: flex-end;*/
        /*margin-right: 20px;*/
        /*padding: 5px 0;*/
        img{
            position: absolute;
            top: 15px;
            right: 25px;
            width: 30px;
            height: 30px;
        }
    }

    .survey_bottom {
        width: 100%;
        height: 18%;
        background: transparent url("../../assets/img/survey_bottom.png") no-repeat;
        background-size: 100% 100%;
    }

    .deep {
        // background: #FFF;
        margin: 28px 0;
    }

    .red {
        color: red;
        vertical-align: middle;
    }


    .licence_img {
        position: absolute;
        right: 0;
        top: 0;
        opacity: 0;
    }

    .licence_img_show {
        position: absolute;
        top: -5px;
        right: -35px;

        img {
            width: 30px;
            height: 30px;
        }
    }

    .popup {
        width: 100%;
    }

    .usi-btn-cancel,
    .usi-btn-sure {
        color: #10a19a;
    }

    .picker-toolbar-title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }

    input::-webkit-input-placeholder {
        color: #C3BFBF;
        /*font-size:12px;*/
    }

    input {
        font-size: 13px;
    }

    .arrow {
        /*border-top: 1px #000 solid;*/
        /*background: red;*/
        width: 8px;
        height: 8px;
        border-top: 1px solid #666;
        border-right: 1px solid #666;
        margin-right: 10px;
        transform: rotate(45deg);
    }
    
    .introduce{
        background: #e9f2ea;
        text-align: left;
        font-size: 10px;
        margin:10px 20px;
        padding: 10px 0;
        text-indent: 28px;
        line-height: 20px;
        word-wrap:normal;
        word-break:break-all;
    }

    .mint-msgbox-confirm{
        font-size: 20px;
    }

</style>
